import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";
import { IPolicies } from "../types/InsuredPersons-interface";
interface IFilters {
  Field: string;
  ComparisonType: string;
  Value: string | boolean;
}
const POLICIES_LIMIT = 10000;

export const fetchInsuredPersonsList = createAsyncThunk(
  "contract/fetchInsuredPersonsList",

  async (
    {
      contractID,
      sortArray,
      filters,
    }: {
      contractID: string[];
      sortArray: string[] | [];
      filters: IFilters[] | [];
    },
    { rejectWithValue }
  ) => {
    try {
      let offset = 0;
      let policyCount = 0;

      const policies: IPolicies[] = [];

      do {
        const requestBody = {
          Limit: POLICIES_LIMIT,
          Offset: offset,

          ...(contractID.length > 0 && {
            ContractIDs: contractID,
          }),

          SortableColumns: sortArray,
          Filters: filters,
        };

        const response = await getRequest(
          requestBody,
          "dms-hr",
          "getInsuredPersons",
          "POST"
        );

        const data = await response.json();

        if (data.Errors?.length > 0) {
          return rejectWithValue(data.Errors);
        }

        const batch: IPolicies[] = data.Policies ?? [];

        policies.push(...batch);

        policyCount = data.PolicyCount ?? 0;

        offset += POLICIES_LIMIT;

        if (batch.length === 0) {
          break;
        }
      } while (offset < policyCount);

      return {
        policies,
        policyCount,
        fetchTime: parseToTimestamp(new Date()),
        contractID,
      };
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchPoliciesDownload = createAsyncThunk(
  "contract/fetchPoliciesDownload",
  async (
    {
      Filters,
    }: {
      Filters: IFilters[];
    },
    { rejectWithValue }
  ) => {
    try {
      const requestBody = {
        Filters: Filters,
      };

      const response = await getRequest(
        requestBody,
        "dms-hr",
        "downloadPoliciesFile",
        "POST"
      );
      const data = await response.json();
      if (data.Errors.length === 0) {
        return { FileData: data.File.DataBase64, FileName: data.File.Name };
      } else {
        return rejectWithValue(data.Errors);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
